//constants
export const OPEN_SIDEBAR_MENU = "OPEN_SIDEBAR_MENU";
export const CLOSE_SIDEBAR_MENU = "CLOSE_SIDEBAR_MENU";
//action creators
export const openSidebarMenu = () => {
  return { type: OPEN_SIDEBAR_MENU };
};
export const closeSidebarMenu = () => {
  return { type: CLOSE_SIDEBAR_MENU };
};
